import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RatesTemplate from './ratesTemplate';
import RateTemplate from '../../models/rateTemplate';
import RateTemplateGroup from '../../models/rateTemplateGroup';
import RateForm from './rateForm';
import PageError from '../error/pageError';

export default class RatesOrganization extends React.Component {
    render() {
        const { path } = this.props;
        const organizationId = this.props.organization.id;

        return (
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={({ match, history }) => {
                        return <RatesTemplate organization={this.props.organization} match={match} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/new`}
                    render={({ match, history }) => {
                        return <RateForm organizationId={organizationId} history={history} RateClass={RateTemplate} GroupClass={RateTemplateGroup} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/:rateId`}
                    render={basenameProps => {
                        const rateId = basenameProps.match.params.rateId;
                        return <RateForm rateId={rateId} organizationId={organizationId} history={basenameProps.history} RateClass={RateTemplate} GroupClass={RateTemplateGroup} />;
                    }}
                />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organizationId}`} />} />
            </Switch>
        );
    }
}

RatesOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
